import { getTree } from '@/apis/orange'

const state = {
  treeData: [],
  isLoading: false,
  lastUpdateTime: null,
  updateListeners: [] // 存储需要通知更新的组件
}

const mutations = {
  SET_TREE_DATA(state, data) {
    state.treeData = data
  },
  SET_LOADING(state, loading) {
    state.isLoading = loading
  },
  SET_LAST_UPDATE_TIME(state, time) {
    state.lastUpdateTime = time
  },
  ADD_UPDATE_LISTENER(state, listener) {
    if (!state.updateListeners.includes(listener)) {
      state.updateListeners.push(listener)
    }
  },
  REMOVE_UPDATE_LISTENER(state, listener) {
    const index = state.updateListeners.indexOf(listener)
    if (index > -1) {
      state.updateListeners.splice(index, 1)
    }
  },
  CLEAR_UPDATE_LISTENERS(state) {
    state.updateListeners = []
  }
}

const actions = {
  // 获取树形数据
  async fetchTreeData({ commit, state }) {
      // 如果有缓存数据，直接返回
    if (state.treeData && state.treeData.length > 0) {
      return state.treeData
    }
    // 如果正在加载，直接返回
    if (state.isLoading) {
      return state.treeData
    }

    commit('SET_LOADING', true)
    
    try {
      const response = await getTree()
      const data = response.data.data
      const processedData = adjustCascaderData(data)
      
      commit('SET_TREE_DATA', processedData)
      commit('SET_LAST_UPDATE_TIME', new Date().getTime())
      
      return processedData
    } catch (error) {
      console.error('获取树形数据失败:', error)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // 强制刷新数据
  async refreshTreeData({ commit, dispatch, state }) {
    commit('SET_LOADING', true)
    
    try {
      const response = await getTree()
      const data = response.data.data
      const processedData = adjustCascaderData(data)
      
      commit('SET_TREE_DATA', processedData)
      commit('SET_LAST_UPDATE_TIME', new Date().getTime())
      
      // 通知所有监听器数据已更新
      state.updateListeners.forEach(listener => {
        if (typeof listener === 'function') {
          listener(processedData)
        }
      })
      
      return processedData
    } catch (error) {
      console.error('刷新树形数据失败:', error)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // 注册更新监听器
  registerUpdateListener({ commit }, listener) {
    commit('ADD_UPDATE_LISTENER', listener)
  },

  // 移除更新监听器
  unregisterUpdateListener({ commit }, listener) {
    commit('REMOVE_UPDATE_LISTENER', listener)
  },

  // 清除所有监听器
  clearUpdateListeners({ commit }) {
    commit('CLEAR_UPDATE_LISTENERS')
  }
}

const getters = {
  treeData: state => state.treeData,
  isLoading: state => state.isLoading,
  lastUpdateTime: state => state.lastUpdateTime,
  hasData: state => state.treeData.length > 0
}

// 处理树形数据的辅助函数
function adjustCascaderData(data) {
  return data.map(item => {
    if (item.children && item.children.length === 0) {
      delete item.children // 删除空的 children 数组
    } else if (item.children) {
      item.children = adjustCascaderData(item.children)
    }
    return item
  })
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 